export default "__VITE_ASSET__BrLgBUs8__"